(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["diy-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('diy-newsletter-popup')) {
    customElements.define('diy-newsletter-popup', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.querySelector('.diy-newsletter__close').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        }, options);
        if (window.Shopify?.designMode) {
          document.addEventListener('shopify:section:select', (event) => {
            if (event.detail.sectionId === this.dataset.sectionId) this.open(false);
          }, options);
          document.addEventListener('shopify:section:deselect', () => this.dialog.close(), options);
          return;
        }
        const hasResult = this.querySelector('[data-form-result]') && location.hash === '#' + this.querySelector('form').id;
        if (hasResult) { this.open(false); return; }
        try {
          if (this.dataset.once === 'true' && localStorage.getItem('theme:popup-appeared')) return;
        } catch {}
        this.timer = setTimeout(() => this.open(true), Number(this.dataset.delay) || 5000);
      }
      open(remember) {
        if (!this.isConnected || this.dialog.open) return;
        this.dialog.showModal();
        if (remember && this.dataset.once === 'true') {
          try { localStorage.setItem('theme:popup-appeared', 'true'); } catch {}
        }
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.dialog?.close();
        this.abort?.abort();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
